import {useState} from "react";
import "./Technical.css";
import ClassiclePivot from "./ClassiclePivot";
import FibPivot from "./FibPivot";
import CamPivot from "./CamPivot";

export default function Technical(props) {
  const item = props.techdata;
  const [pivot, setPivot] = useState('Classic');
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <table className="table_content technical-table">
            <tbody>
              <tr className="table_rows">
                <td className="boldfont">LTP</td>
                <td>{item.ltp ? item.ltp : ""}</td>
                <td className="boldfont">%Chg</td>
                <td>{item.cp ? item.cp : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Change</td>
                <td>{item.chg ? item.chg : ""}</td>
                <td className="boldfont">Earning</td>
                <td>{item.eps ? item.eps : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Open</td>
                <td>{item.op ? item.op : ""}</td>
                <td className="boldfont">52 WH</td>
                <td>{item.hi52 ? item.hi52 : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">High</td>
                <td>{item.hi ? item.hi : ""}</td>
                <td className="boldfont">52 WL</td>
                <td>{item.lo52 ? item.lo52 : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Low</td>
                <td>{item.lo ? item.lo : ""}</td>
                <td className="boldfont">Vol</td>
                <td>{item.volume ? item.volume : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Pr.Close</td>
                <td>{item.pcls_fix ? item.pcls_fix : ""}</td>
                <td className="boldfont">Mkt cap</td>
                <td>{item.mc ? item.mc : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">P/E</td>
                <td>{item.pe ? item.pe : ""}</td>
                <td className="boldfont">Beta</td>
                <td>{item.beta ? item.beta : ""}</td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont">Av. Volume</td>
                <td></td>
                <td className="boldfont">ATP(Aprox. )</td>
                <td>{item.avtp ? item.avtp : "1"}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Last Vol</td>
                <td>{item.l_vo ? item.l_vo : ""}</td>
                <td className="boldfont">Vol %</td>
                <td>{item.avvo ? item.avvo : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">5 DMA</td>
                <td>{item.vfivedma ? item.vfivedma : 0}</td>
                <td className="boldfont">20 DMA</td>
                <td>{item.vtwentydma ? item.vtwentydma : 0}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">10 DMA</td>
                <td>{item.vtendma ? item.vtendma : 0}</td>
                <td className="boldfont">50 DMA</td>
                <td>{item.vfiftydma ? item.vfiftydma : 0}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Rs 1 Month</td>
                <td>{item.onemonthrs ? item.onemonthrs : 0} </td>
                <td className="boldfont">Rs 6 Month</td>
                <td> {item.sixmonthrs ? item.sixmonthrs : 0}</td>
              </tr>
              <tr className="table_rows highlited_row">
                <td className="boldfont">Pivot Point</td>
                <td></td>
                <td className="boldfont">LTP</td>
                <td>{item.l_cur ? item.l_cur : ""} </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <button onClick={()=>setPivot('Classic') } className={`btn mr-1 btn-sm ${pivot === 'Classic' ? 'btn-success' : 'btn-default'}`} >Classic</button> 
                  <button onClick={()=>setPivot('Fibonacci') } className={`btn mr-1 btn-sm ${pivot === 'Fibonacci' ? 'btn-success' : 'btn-default'}`}>Fibonacci</button> 
                  <button onClick={()=>setPivot('Camarilla') } className={`btn mr-1 btn-sm ${pivot === 'Camarilla' ? 'btn-success' : 'btn-default'}`}>Camarilla</button>
                </td>
                <td></td>
              </tr>

              {pivot === 'Classic' && <ClassiclePivot item={item} />}
              {pivot === 'Fibonacci' && <FibPivot item={item} />}
              {pivot === 'Camarilla' && <CamPivot item={item} /> }

              <tr className="table_rows highlited_row">
                <td className="boldfont">Sell Below</td>
                <td></td>
                <td className="boldfont">Buy Above</td>
                <td></td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">Intraday</td>
                <td> {item.sintraday ? item.sintraday : ""} </td>
                <td className="boldfont">Intraday</td>
                <td>{item.bintraday ? item.bintraday : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Shot Term</td>
                <td>{item.sshortterm ? item.sshortterm : ""} </td>
                <td className="boldfont">Shot Term</td>
                <td>{item.bshortterm ? item.bshortterm : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Long Term</td>
                <td>{item.slongterm ? item.slongterm : ""} </td>
                <td className="boldfont">Long Term</td>
                <td>{item.blongterm ? item.blongterm : ""} </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-6">
          <table className="table_content">
            <tbody>
              <tr className="table_rows highlited_row">
                <td className="boldfont">Buy Target</td>
                <td></td>
                <td className="boldfont">Sell Target</td>
                <td className="boldfont"></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Intraday</td>
                <td>{item.btintraday ? item.btintraday : ""} </td>
                <td className="boldfont">Intraday</td>
                <td>{item.stintraday ? item.stintraday : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">Shot Term</td>
                <td>{item.btshortterm ? item.btshortterm : ""} </td>
                <td className="boldfont">Shot Term</td>
                <td>{item.stshortterm ? item.stshortterm : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">Long Term</td>
                <td>{item.btlongterm ? item.btlongterm : ""} </td>
                <td className="boldfont">Long Term</td>
                <td>{item.stlongterm ? item.stlongterm : ""} </td>
              </tr>
              <tr className="table_rows highlited_row">
                <td className="boldfont">H,L,C</td>
                <td className="boldfont">High</td>
                <td className="boldfont">Low</td>
                <td className="boldfont">Close</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">L Day</td>
                <td>{item.high ? item.high : ""} </td>
                <td> {item.low ? item.low : ""}</td>
                <td>{item.close ? item.close : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">L Week</td>
                <td> {item.whigh ? item.whigh : ""}</td>
                <td>{item.wlow ? item.wlow : ""}</td>
                <td>{item.wclose ? item.wclose : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">L Month</td>
                <td> {item.mhigh ? item.mhigh : ""}</td>
                <td>{item.mlow ? item.mlow : ""}</td>
                <td>{item.mclose ? item.mclose : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">L3 Months</td>
                <td>{item.tmhigh ? item.tmhigh : ""} </td>
                <td>{item.tmlow ? item.tmlow : ""}</td>
                <td>{item.tmclose ? item.tmclose : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">L6 Months</td>
                <td>{item.smhigh ? item.smhigh : ""} </td>
                <td>{item.smlow ? item.smlow : ""}</td>
                <td>{item.smclose ? item.smclose : ""}</td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont"> Movining Av.(SMA)</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">Daily</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">5 DMA</td>
                <td>{item.mfivedma ? item.mfivedma : ""} </td>
                <td className="boldfont">50 DMA</td>
                <td>{item.mfiftydma ? item.mfiftydma : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">10 DMA</td>
                <td>{item.mtendma ? item.mtendma : ""} </td>
                <td className="boldfont">89 DMA</td>
                <td>{item.meightyninedma ? item.meightyninedma : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">20 DMA</td>
                <td>{item.mtwentydma ? item.mtwentydma : " "} </td>
                <td className="boldfont">100 DMA</td>
                <td>{item.mhundreddma ? item.mhundreddma : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">30 DMA</td>
                <td>{item.mthirtydma ? item.mthirtydma : ""} </td>
                <td className="boldfont">150 DMA</td>
                <td> {item.monefiftydma ? item.monefiftydma : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">34 DMA</td>
                <td>{item.mthirtyfourdma ? item.mthirtyfourdma : ""} </td>
                <td className="boldfont">200 DMA</td>
                <td>{item.mtwohundreddma ? item.mtwohundreddma : ""} </td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont">Weekly</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">5 DMA</td>
                <td>{item.fiveweeks ? item.fiveweeks : ""} </td>
                <td className="boldfont">30 DMA</td>
                <td>{item.thirtyweeks ? item.thirtyweeks : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">10 DMA</td>
                <td>{item.tenweeks ? item.tenweeks : ""} </td>
                <td className="boldfont">34 DMA</td>
                <td>{item.thirtyfourweeks ? item.thirtyfourweeks : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">20 DMA</td>
                <td>{item.twentyweeks ? item.twentyweeks : ""} </td>
                <td className="boldfont">50 DMA</td>
                <td>{item.fiftyweeks ? item.fiftyweeks : ""} </td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont">Performance</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">T Chg(%)</td>

                <td>{item.cp ? item.cp : ""} % </td>
                <td className="boldfont">3 Months</td>
                <td> {item.threemonthpers ? item.threemonthpers : ""} %</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">1 Week</td>
                <td>{item.weekpers ? item.weekpers : ""} %</td>
                <td className="boldfont"> 6 Months</td>
                <td>{item.sixmonthpers ? item.sixmonthpers : ""} %</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">1 Month</td>

                <td>{item.onemonthpers ? item.onemonthpers : ""}% </td>
                <td className="boldfont">9 month</td>
                <td>{item.ninemonthpers ? item.ninemonthpers : ""}% </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">1 Year</td>
                <td>{item.oneyearpers ? item.oneyearpers : ""} % </td>
                <td className="boldfont">YTD</td>
                <td>{item.ytds ? item.ytds : ""} %</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
